<template>
  <div class="tts" v-if="isEnabled">
    <div v-if="isOpened" class="tts__player">
      <div v-if="title" class="tts__player-title">
        <UTooltip class="align-middle" :text="$t('articles.tts_tooltip')">
          <DefaultIconsTooltip class="fill-white/35 w-5"/>
        </UTooltip>
        <span class="tts__player-title-text" :title="title">
          {{title}}
        </span>
      </div>
      <div class="tts__player-inner">
        <iframe
          v-if="id && src"
          :src="src"
          style="width: 100%; height: 165px; border: 0;"
          allow="autoplay"
        ></iframe>
      </div>
      <NuxtLink class="tts__player-close-btn" @click="closePlayer">
        <!-- todo - create icon component -->
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted} from "vue"
import type TtsPlayerEventPayload from "~/libs/interfaces/TtsPlayerEventPayload"
import {TtsPlayerVoice} from "~/libs/interfaces/TtsPlayerVoice"
import type {TtsIframeUrlParams} from "~/composables/useTts"

const id = ref<string|null|undefined>(null)
const title = ref<string|null|undefined>(null)
const voice = ref<TtsPlayerVoice>(TtsPlayerVoice.MALE)
const autoplay = ref<boolean>(true)
const startTime = ref<number>(0)
const isOpened = ref(false)

const openPlayer = () => {
  isOpened.value = true
}

const closePlayer = () => {
  isOpened.value = false
}

const isEnabled = computed(() => {
  return useTts().isEnabled()
})

const src = computed(() => {
  if (id.value) {
    const payload: TtsIframeUrlParams = {
      id: id.value,
      voice: voice.value,
      autoplay: autoplay.value,
      startTime: startTime.value
    }
    return useTts().getIframeUrl(payload)
  }
  return null
})

onMounted(() => {
  // open player handle
  // stories fullscreen event handle
  useListen('tts-player:open', (payload: TtsPlayerEventPayload) => {
    if (payload.id) {
      id.value = payload.id
      title.value = payload.title
      if (typeof payload.autoplay !== 'undefined') {
        autoplay.value = !!payload.autoplay
      }
      if (typeof payload.startTime !== 'undefined' && payload.startTime >= 0) {
        startTime.value = payload.startTime
      }
      isOpened.value = true
    }
  })
})
</script>

<style lang="scss" scoped>
</style>
